import * as React from "react";
const SvgFiRrCheese = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-cheese_svg__a)">
      <path d="M17 14a2 2 0 1 0 0 4 2 2 0 0 0 0-4M8 11a4 4 0 1 0 0 8 4 4 0 0 0 0-8m0 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4" />
      <path d="M21.589 6.7 13.751.849A4.96 4.96 0 0 0 8.043.96 19.9 19.9 0 0 0 1.1 10.569a1 1 0 0 0-.032.156q-.165.325-.283.669a13.86 13.86 0 0 0 0 9.213A5 5 0 0 0 5.525 24h3.624a2.04 2.04 0 0 0 1.922-1.457 1.509 1.509 0 0 1 2.858 0A2.04 2.04 0 0 0 15.851 24H19a5.006 5.006 0 0 0 5-5v-7.493A6.03 6.03 0 0 0 21.589 6.7M9.24 2.562a2.94 2.94 0 0 1 3.359-.08L19.989 8H5.526q-.586 0-1.156.135a18.2 18.2 0 0 1 4.87-5.573M22 19a3 3 0 0 1-3 3l-3.166-.066A3.511 3.511 0 0 0 9.149 22H5.525a3 3 0 0 1-2.843-2.038 11.87 11.87 0 0 1 0-7.923A3.01 3.01 0 0 1 5.526 10H21.7c.196.478.298.99.3 1.507z" />
    </g>
    <defs>
      <clipPath id="fi-rr-cheese_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrCheese;
